// extracted by mini-css-extract-plugin
export default {"SubscribeForm":"SubscribeForm_SubscribeForm__MwI9z","Form":"SubscribeForm_Form__36NNa","Link":"SubscribeForm_Link__ao-jt"};